<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="{ 'navbar-dark': type === 'default' }"
  >
    <!-- Search form -->
    <b-form
      class="navbar-search form-inline mr-sm-3"
      :class="{ 'navbar-search-light': type === 'default', 'navbar-search-dark': type === 'light' }"
      id="navbar-search-main"
    >
      <b-form-group class="mb-0">
        <b-input-group class="input-group-alternative input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fas fa-search"></i></span>
          </div>
          <b-form-input placeholder="Search Recipes" type="text" autocomplete="off" class="js-header-search" value="searchQuery" @keydown.native="checkEnter($event)" @input.native="handleAutocomplete($event)" @submit.native="loadSearchResults($event)" v-model="searchQuery" @focus.native="searchModalVisible = true"> </b-form-input>
        </b-input-group>
      </b-form-group>
      <button type="button" class="close" data-action="search-close" data-target="#navbar-search-main" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>

      <div class="navbar-search__autocomplete" v-if="filteredResults.length && searchModalVisible">
        <ul>
          <li v-for="(filteredResult, index) in filteredResults.slice(0,10)" :key="index" :data-id="filteredResult.id" @click="setResult(filteredResult)">{{ filteredResult.name }}</li>
        </ul>
      </div><!-- /.navbar-search__autocomplete -->
    </b-form>
    <!-- Navbar links -->
    <b-navbar-nav class=" align-items-center ml-md-auto">
      <!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div
          class="pr-3 sidenav-toggler"
          :class="{ active: $sidebar.showSidebar, 'sidenav-toggler-dark': type === 'default', 'sidenav-toggler-light': type === 'light' }"
          @click="toggleSidebar"
        >
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
      <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->
      <li class="nav-item d-sm-none">
        <a class="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li>
      <!-- <li class="nav-item nav-link requests-icon" style="color: white">
        <router-link to="/requests"> <i class="ni ni-bell-55"></i></router-link>
      </li> -->
      <base-dropdown
        menu-classes="dropdown-menu-lg dropdown-menu-dark bg-default dropdown-menu-right"
        class="nav-item"
        tag="li"
        title-tag="a"
        title-classes="nav-link"
        icon="ni ni-ungroup"
        v-if="this.$store.getters.userIsAdmin"
      >
        <template>
          <b-row class="shortcuts px-4">
            <h3 class="col-12 text-center">Administrative Tools</h3>
            <router-link
              to="/taggroups"
              class="col-4 shortcut-item">
              <span class="shortcut-media avatar rounded-circle bg-gradient-purple">
                <i class="fas fa-tag"></i>
              </span>
              <small>Tag Groups</small>
            </router-link>
            <router-link
              to="/tags"
              class="col-4 shortcut-item">
              <span class="shortcut-media avatar rounded-circle bg-gradient-yellow">
                <i class="fas fa-tag"></i>
              </span>
              <small>Tags</small>
            </router-link>
            <a href="/users" class="col-4 shortcut-item">
              <span class="shortcut-media avatar rounded-circle bg-gradient-info">
                <i class="ni ni-single-02"></i>
              </span>
              <small>Users</small>
            </a>
            <a href="/units" class="col-4 shortcut-item">
              <span class="shortcut-media avatar rounded-circle bg-gradient-orange">
                <i class="fa fa-utensil-spoon"></i>
              </span>
              <small>Units</small>
            </a>
            <a href="/recipes/uploader" class="col-4 shortcut-item">
              <span class="shortcut-media avatar rounded-circle bg-gradient-purple">
                <i class="fa fa-utensil-spoon"></i>
              </span>
              <small>Uploader</small>
            </a>
            <!--
            <a href="/adminreporting" class="col-4 shortcut-item">
              <span class="shortcut-media avatar rounded-circle bg-gradient-orange">
                <i class="ni ni-shop"></i>
              </span>
              <small>Admin Reporting</small>
            </a>
            -->
          </b-row>
        </template>
      </base-dropdown>
    </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <base-dropdown menu-on-right class="nav-item" tag="li" title-tag="a" title-classes="nav-link pr-0">
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="Image placeholder" :src="user && user.image !== null ? user.image.absoluteUri : '/img/DefaultUser.gif'" />
            </span>
            <b-media-body class="ml-2 d-none d-lg-block">
              <span class="mb-0 font-weight-bold avatar-text">{{ user && user.firstName ? user.firstName: '' }} <b v-if="isAdmin">(ADMIN)</b></span>
            </b-media-body>
          </b-media>
        </a>

        <template>
          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">Welcome!</h6>
          </b-dropdown-header>
          <b-dropdown-item @click="loadMyProfile()">
            <i class="ni ni-single-02"></i>
            <span>My profile</span>
          </b-dropdown-item>
          <b-dropdown-item @click="load2fa()">
            <i class="ni ni-single-02"></i>
            <span>2FA Authentication</span>
          </b-dropdown-item>
          <b-dropdown-item href="#!">
            <i class="ni ni-settings-gear-65"></i>
            <span>Settings</span>
          </b-dropdown-item>
          <b-dropdown-item href="#!">
            <i class="ni ni-calendar-grid-58"></i>
            <span>Requests</span>
          </b-dropdown-item>
          <b-dropdown-item @click="loadPrivacyPolicy()">
            <i class="ni ni-single-02"></i>
            <span>Privacy Policy</span>
          </b-dropdown-item>
          <!--b-dropdown-item href="#!">
            <i class="ni ni-support-16"></i>
            <span>Support</span>
          </b-dropdown-item> -->
          <div class="dropdown-divider"></div>
          <b-dropdown-item @click="logout()">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </b-dropdown-item>       
        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';
import { authHeader } from '@/_helpers';

export default {
  
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
  },
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)',
    },
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: this.$route.query.search,
      filteredResults: [],
      timer: undefined
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.userIsAdmin
    },
    user() {
      //return localStorage.getItem('user');
      return this.$store.state.authentication.user.user
    },
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  methods: {
    logout() {
      const { dispatch } = this.$store;
      dispatch('authentication/logout');
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    handleSearchPage(id) {
      let route = `/recipe/${id}`;
      if (route) {
        this.$router.push({
          path: route
        }).catch(() => {});
      }
    },
    handleSearchTermSubmit(val){
      let route = `/recipes?searchQuery=${val}`;
      this.$router.push(route);
    },
    handleAutocomplete(event) {
      this.searchQuery = event.target.value;

      clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        let requestOptions = {
          method: 'GET',
          headers: authHeader(),
        };
        fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/recipes?searchQuery=${this.searchQuery}`, requestOptions).then(res => res.json()).then(res => {
          this.filteredResults = res.results;
        });
      }, 500)
    },
    loadMyProfile() {
      this.$router.push({
          name: "User Profile",
          params: {
            id: this.user.id
          }
      });
    },
    load2fa() {
      this.$router.push({
        name: "2FA Authentication",
        params: {
          id: this.user.id
        }
      })
    },
    loadPrivacyPolicy() {
      this.$router.push('/privacypolicy');
    },
    setResult(result) {
      this.searchQuery = result.title;
      this.searchModalVisible = false;
      this.handleSearchPage(result.id);
    },
    checkEnter(event) {
      if (event.keyCode === 13) {
        event.preventDefault();

        this.searchModalVisible = false;

        if (event.target.value.length) {
          this.searchQuery = event.target.value;
          event.target.value = '';
          this.handleSearchTermSubmit(this.searchQuery);
        }
      }
    }
  },
  mounted() {
    let _this = this;

    document.addEventListener('click', function(event) {
      let target = event.target;

      if (!target.classList.contains('js-header-search')) {
        _this.searchModalVisible = false;
      }
    });
  }
};
</script>
